export default __webpack_public_path__ + "static/media/boatpic2.3b45814d.jpg";